import {jwtDecode} from "jwt-decode";
import {Link, useLocation} from "react-router-dom";

import {TokenPayload} from "../../types/ComponentProps";
import HomeIcon from "../../assets/img/navicons/home-icon.svg";
import ShopIcon from "../../assets/img/navicons/shop-icon.svg";
import CareersIcon from "../../assets/img/navicons/careers-icon.svg";
import WalletIcon from "../../assets/img/navicons/wallet-icon.png";

import AdminLinksStyles from "./AdminLinks.module.css";

const AdminLinks = () => {
  const location = useLocation();
  const userDetails = jwtDecode<TokenPayload>(
    JSON.stringify(localStorage.getItem("accessTokenGC")),
  );

  const allowedCoinGiverIds = (process.env.REACT_APP_COIN_GIVER_IDS || "")
    .split(",")
    .map((id) => Number(id.trim()))
    .filter((id) => !isNaN(id) && id > 0);

  const canGiveCoins =
    userDetails?.isAdmin ||
    (userDetails?.id && allowedCoinGiverIds.includes(userDetails.id));

  return (
    <div>
      <div className={`flex-box-blk ${AdminLinksStyles.flexBoxBlk}`}>
        <Link to="/" className={location.pathname === "/" ? "nav-active" : ""}>
          <img src={HomeIcon} alt="Home" />
          Home
        </Link>
        <Link
          to="/shop"
          className={location.pathname === "/shop" ? "nav-active" : ""}>
          <img src={ShopIcon} alt="Shop" />
          Shop
        </Link>
        <a
          href="https://www.icxeed.careers/"
          target="_blank"
          rel="noopener noreferrer">
          <img src={CareersIcon} alt="Careers" /> Careers
        </a>
        {userDetails?.isAdmin ? (
          <Link to="/users">
            Admin{" "}
            <i
              className="fa-solid fa-chevron-down"
              style={{marginLeft: "10px"}}
            />
          </Link>
        ) : null}
        {canGiveCoins ? (
          <Link to="/give-coins">
            <img src={WalletIcon} alt="Coins" /> Coins
          </Link>
        ) : null}
      </div>
    </div>
  );
};

export default AdminLinks;
